import Button, { ButtonProps } from '../Button/Button';
import { ReactComponent as Spinner } from '../Onboarding/spinner-solid.svg';

import styles from './Buttons.module.scss';

interface ButtonWithLoadingProps extends ButtonProps {
  loading: boolean;
}

const ButtonWithLoading = ({ loading, children, ...rest }: ButtonWithLoadingProps) => {
  const disabled = loading || rest.disabled;

  return (
    <Button {...rest} disabled={disabled}>
      {loading ? (
        <div className={loading ? styles.disabled : ''}>
          <Spinner />
        </div>
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonWithLoading;
